import { useQueryClient } from '@tanstack/react-query'

import type { Products } from '@/api/products'

/** Μετά από κάθε αλλαγή προϊόντος, και η λίστα και οι προμηθευτές αλλάζουν. */
export function useProductsCache() {
  const queryClient = useQueryClient()
  return (data: Products) => {
    queryClient.setQueryData(['products'], data)
    void queryClient.invalidateQueries({ queryKey: ['shopping-list'] })
    void queryClient.invalidateQueries({ queryKey: ['suppliers'] })
  }
}
